<mat-tab-group>
  <mat-tab [label]="'Coach Applications' | translate">
    <div class="filter-container" style="display: flex; gap: 1rem; margin-top: 1rem">
      <mat-form-field appearance="outline">
        <mat-label>{{'Search by Course' | translate}}</mat-label>
        <mat-select (selectionChange)="onCourseFilterChange()" [(ngModel)]="filterCourseId">
          <mat-option value="">{{'All Courses' | translate}}</mat-option>
          <mat-option *ngFor="let course of courses" [value]="course.id">{{course.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'Search by Name or Surname' | translate}}</mat-label>
        <input (ngModelChange)="onFilterInputChange()" [(ngModel)]="filterName" matInput>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'Search Personal ID' | translate}}</mat-label>
        <input (ngModelChange)="onFilterInputChange()" [(ngModel)]="filterPersonalNumber" matInput>
      </mat-form-field>

      <button (click)="clearFilter()" color="secondary" mat-raised-button
              style="height: 55px">{{'Clear' | translate}}</button>
    </div>

    <table [dataSource]="coachApplications" class="mat-elevation-z8" mat-table>
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell> {{ 'Name' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.name}} </td>
      </ng-container>

      <ng-container matColumnDef="surname">
        <th *matHeaderCellDef mat-header-cell> {{ 'Surname' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.surname}} </td>
      </ng-container>

      <ng-container matColumnDef="courseName">
        <th *matHeaderCellDef mat-header-cell> {{ 'Course' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.courseName}} </td>
      </ng-container>

      <ng-container matColumnDef="personalNumber">
        <th *matHeaderCellDef mat-header-cell> {{ 'Personal Number' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.personalNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th *matHeaderCellDef mat-header-cell> {{ 'Email' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.email}} </td>
      </ng-container>

      <ng-container matColumnDef="dateOfBirth">
        <th *matHeaderCellDef mat-header-cell> {{ 'Date of Birth' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.dateOfBirth | date:'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="gender">
        <th *matHeaderCellDef mat-header-cell> {{ 'Gender' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.gender}} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell> {{ 'Status' | translate }}</th>
        <td *matCellDef="let coach" mat-cell> {{coach.status}} </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="openStatusDialog(row)" *matRowDef="let row; columns: displayedColumns;" class="clickable-row"
          mat-row></tr>
    </table>

    <mat-paginator [pageSize]="pageSize"></mat-paginator>
  </mat-tab>

  <mat-tab [label]="'Courses' | translate">
    <div style="margin-top: 1rem">
      <app-courses></app-courses>
    </div>
  </mat-tab>
</mat-tab-group>
